import React from "react";
import axios from "services/axiosB2C";
import Axios from "axios";
import { Link } from "react-router-dom";

import { Button, Card, message, Spin, Tooltip, Modal, DatePicker } from "antd";
import MUIDataTable from "mui-datatables";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import momentTZ from "moment-timezone";
import _ from "lodash";

import { RequestToken } from "../../../../services/b2c";
import { errorMessage } from "../../../Utils";
import ModalCustomerDetail from "./Modal/ModalCustomerDetail";
import downloadExcel from "../../../../services/downloadExcel";

let cancelToken;
const { RangePicker } = DatePicker;

class CustomerList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      customerDetail: {},
      customerList: [],
      page: 1,
      limit: 15,
      count: 0,
      search: "",
      sort: { name: "create", direction: "desc" },
      isLoading: false,
      startTime: null,
      endTime: null,
      visibleModalDownload: false,
    };
    this.visibleModalDetail = this.visibleModalDetail.bind(this);
  }

  componentDidMount() {
    this.fetchCustomer(this.state.page, this.state.limit);
  }

  async fetchCustomer(page, limit) {
    this.setState({ isLoading: true });

    let { sort, search } = this.state;
    let order = this.orderBy(sort);
    let query = `${order}&page=${page}&limit=${limit}&search=${search || ""}`;

    if (cancelToken) {
      cancelToken.cancel("Operation canceled due to new request");
    }
    cancelToken = Axios.CancelToken.source();

    let token = await RequestToken();
    await axios
      .get(`/users?${query}`, {
        cancelToken: cancelToken.token,
        headers: {
          Authorization: token,
        },
      })
      .then(result => {
        this.setState({
          customerList: result.data.users,
          page: result.data.page,
          limit: result.data.limit,
          count: result.data.count,
          isLoading: false,
        });
      })
      .catch(err => {
        if (!Axios.isCancel(err)) {
          errorMessage(err.response || err);
          this.setState({ isLoading: false });
        }
      });
  }

  orderBy(sort) {
    let key = "date";
    let value = "desc";

    //Get Key
    if (sort.name === "Hari/Tgl Dibuat") key = "create";

    //Get Value
    if (sort.direction === "asc") value = "asc";
    else if (sort.direction === "desc") value = "desc";

    return `sort_by=${key}&order_by=${value}`;
  }

  changePage(page, limit) {
    this.setState({ isLoading: true });
    this.fetchCustomer(page, limit);
  }

  visibleModalDetail(customer) {
    this.setState({
      visibleModalDetail: !this.state.visibleModalDetail,
      customerDetail: customer,
    });
  }

  visibleModalDownload() {
    this.setState({
      visibleModalDownload: !this.state.visibleModalDownload,
    });
  }

  onChangeRange(date, dateString) {
    this.setState({
      startTime: dateString[0],
      endTime: dateString[1],
    });
  }

  getCustomerCars(user) {
    let cars = [];
    if (user && Array.isArray(user.customercars)) {
      for (let i = 0; i < user.customercars.length; i++) {
        cars = user.customercars;
        // let { brand, spec, year } = user.customercars[i];
        // cars += `${brand} ${spec} ${year}`;

        // if (i + 1 != user.customercars.length) cars += "\n -";
      }
    }

    return (
      <div>
        {cars &&
          cars.map(v => (
            <div>
              <span>{`${v.brand} ${v.spec} ${v.year}`}</span>
              <br />
            </div>
          ))}
      </div>
    );
  }

  getDataCustomer(user, number) {
    return {
      No: number,
      Nama: user.userprofile ? user.userprofile.name : "-",
      Email: user.email,
      "Customer Car": "",
      "No HP": user.userprofile ? user.userprofile.phone : "-",
      "Jenis Kelamin": user.userprofile
        ? user.userprofile.gender == "L"
          ? "Laki-laki"
          : user.userprofile.gender == "P"
          ? "Perempuan"
          : "-"
        : "-",
      "Tempat Lahir": user.userprofile ? user.userprofile.place_of_birth : null,
      "Tanggal Lahir": user.userprofile
        ? user.userprofile.date_of_birth
          ? momentTZ(user.userprofile.date_of_birth)
              .tz("Asia/Jakarta")
              .format("dddd, D MMMM YYYY")
          : "-"
        : "-",
      "Hari/Tgl Register": momentTZ(user.created_at).format(
        "DD/MM/YYYY HH:mm:ss"
      ),
    };
  }

  async confirmationDownload() {
    const { startTime, endTime } = this.state;
    if (startTime && endTime) {
      let token = await RequestToken();
      axios
        .post(
          `/users/download`,
          {
            start_time: startTime,
            end_time: endTime,
          },
          {
            headers: {
              Authorization: token,
            },
          }
        )
        .then(result => {
          if (result.data.users.length > 0) {
            const customers = [];
            let number = 0;
            result.data.users.map((user, index) => {
              number++;
              let { customercars } = user;
              if (Array.isArray(customercars) && customercars.length > 0) {
                for (let i = 0; i < customercars.length; i++) {
                  let { brand, spec, year } = customercars[i];
                  let customer = this.getDataCustomer(user, number);
                  customer["Customer Car"] = `${brand} ${spec} ${year}`;
                  customers.push(customer);
                  number++;
                }
              } else {
                let customer = this.getDataCustomer(user, number);
                customers.push(customer);
              }
            });

            const fileName = `Customer ${momentTZ(startTime)
              .tz("Asia/Jakarta")
              .format("D MMM YYYY")} - ${momentTZ(endTime)
              .tz("Asia/Jakarta")
              .format("D MMM YYYY")}`;

            downloadExcel(customers, fileName);
            this.visibleModalDownload();
          } else {
            message.error("Data Customer Kosong");
          }
        })
        .catch(err => {
          message.error("Gagal mendapatkan data Customer");
        });
    }
  }

  getMuiTheme = () =>
    createMuiTheme({
      typography: {
        useNextVariants: true,
      },
      overrides: {
        MUIDataTableBodyCell: {
          root: {
            "white-space": "nowrap",
            "&:nth-child(1)": {
              width: "8em",
              "min-width": "8em",
              "max-width": "8em",
              "word-break": "break-all",
            },
          },
        },
      },
    });

  render() {
    //Columns
    const columns = [
      {
        name: "Action",
        options: {
          sort: false,
        },
      },
      {
        name: "Email",
        options: {
          sort: false,
        },
      },
      {
        name: "Nama",
        options: {
          sort: false,
        },
      },
      {
        name: "No. HP",
        options: {
          sort: false,
        },
      },
      // {
      //   name: "Customer Car",
      //   options: {
      //     sort: false,
      //   },
      // },
      {
        name: "Hari/Tgl Daftar",
        options: {
          sort: false,
        },
      },
    ];

    // Data Customer Car List //
    const customerList = this.state.customerList.map((item, idx) => {
      return [
        <div>
          <Link to={`/home/customer/${item.id}`}>
            <Tooltip placement="bottom" title="Detail Customer">
              <Button icon="bars" style={{ marginRight: 10 }} />
            </Tooltip>
          </Link>
        </div>,
        item.email,
        item.userprofile ? item.userprofile.name : "",
        item.userprofile ? item.userprofile.phone : "",
        // this.getCustomerCars(item),
        momentTZ(item.created_at)
          .tz("Asia/Jakarta")
          .format("dddd, D MMMM YYYY HH:mm"),
      ];
    });

    //Options
    const options = {
      filter: false,
      responsive: "simple",
      fixedHeader: true,
      tableBodyHeight: "460px",
      print: false,
      selectableRows: "none",
      // resizableColumns: true,
      download: false,
      viewColumns: false,
      serverSide: true,
      rowsPerPage: parseInt(this.state.limit),
      count: this.state.count,
      page: this.state.page - 1,
      searchText: this.state.search,
      sortOrder: this.state.sort,
      onTableChange: (action, tableState) => {
        switch (action) {
          case "changePage":
            this.changePage(tableState.page + 1, tableState.rowsPerPage);
            break;
          case "changeRowsPerPage":
            this.changePage(1, tableState.rowsPerPage);
            break;
          case "search":
            this.setState({ search: tableState.searchText }, () =>
              this.changePage(1, tableState.rowsPerPage)
            );
            break;
          case "sort":
            this.setState({ sort: tableState.sortOrder }, () =>
              this.changePage(1, tableState.rowsPerPage)
            );
            break;
          default:
            break;
        }
      },
    };

    return (
      <Card
        title="Customer List"
        style={{
          marginTop: 35,
          background: "#fff",
          minHeight: 360,
        }}>
        <Spin size="large" spinning={this.state.isLoading} tip="Loading...">
          <Button onClick={() => this.visibleModalDownload()}>
            Download Data
          </Button>
          <MuiThemeProvider theme={this.getMuiTheme()}>
            <MUIDataTable
              title="Customer"
              data={customerList}
              columns={columns}
              options={options}
            />
          </MuiThemeProvider>
        </Spin>
        <ModalCustomerDetail
          data={this.state.customerDetail}
          visible={this.state.visibleModalDetail}
          visibleModal={this.visibleModalDetail}
        />

        <Modal
          visible={this.state.visibleModalDownload}
          title="Download Data Customer"
          onOk={() => this.confirmationDownload()}
          onCancel={() => this.visibleModalDownload()}
          confirmLoading={this.state.confirmLoading}>
          <p>Pilih range waktu</p>
          <RangePicker
            format="YYYY-MM-DD"
            onChange={(date, dateString) =>
              this.onChangeRange(date, dateString)
            }
          />
        </Modal>
      </Card>
    );
  }
}

export default CustomerList;



// WEBPACK FOOTER //
// src/components/Dashboard/B2C/Customer/Customer.js